import { IRolesContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const RolesContext = createContext<IRolesContextData>({} as IRolesContextData);
